import React from 'react';

const VideoReview = ({ mergedVideoPath, onNext }) => {
  return (
    <div className="p-4">
      <div
       className="max-w-6xl mx-auto">
        <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden">
          {mergedVideoPath ? (
            <video controls autoPlay loop muted src={mergedVideoPath} className="w-full h-full object-cover">
            </video>
          ) : (
            <div className="w-full h-full bg-gray-200 flex items-center justify-center">
              <p>No video to display.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoReview;
